import React from 'react';
import noop from 'lodash/noop';
import { Theme } from '@mui/material';
import { useContent, useContentContext } from '@qbe/dfc-content';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';

import { RadioGroup } from '@qbe/ads-core';
import styled from '@emotion/styled';

interface Props {
  value?: string | null;
  onChange?: (value: string, fields: string[]) => void;
  title: string;
  name: string;
  titlePrefix?: React.ReactNode;
  titleSuffix?: React.ReactNode;
  required?: boolean;
  onAfterChange?: (value: string, fields: string[]) => void;
}

const StyledRadioGroupNewTiled = styled(RadioGroup)`
  .MuiFormControlLabel-root {
    ${({ theme }) => `${(theme as Theme).breakpoints.down('md')} {
      width: 80px !important;
    }`}
  }
  position: static;
`;

const ContactPreferredMethod = ({
  value,
  name,
  onChange = noop,
  title,
  titlePrefix,
  titleSuffix,
  required = true,
  onAfterChange,
}: Props) => {
  const { getTextContent } = useContent({ context: useContentContext() });
  return (
    <StyledRadioGroupNewTiled
      required={required}
      title={title}
      value={value}
      titlePrefix={titlePrefix}
      titleSuffix={titleSuffix}
      name={name}
      styleVariant="tile"
      tileWidth="100px"
      onChange={(value) => {
        onChange(value, ['email', 'post', 'phone']);
        onAfterChange?.(value, ['email', 'post', 'phone']);
      }}
      radioList={
        [
          {
            iconProps: { muiIcon: EmailIcon, color: 'gray', size: 48 },
            id: `${name}_email`,
            label: getTextContent('contactPreferred.email') || 'Email',
            value: 'email',
            'data-track': 'email',
            'data-track-value': 'capture',
          },
          {
            iconProps: { muiIcon: PlaceIcon, color: 'gray', size: 48 },
            id: `${name}_post`,
            label: getTextContent('contactPreferred.post') || 'Post',
            value: 'post',
            'data-track': 'post',
            'data-track-value': 'capture',
          },
          {
            iconProps: { muiIcon: PhoneIcon, color: 'gray', size: 48 },
            id: `${name}_phone`,
            label: getTextContent('contactPreferred.phone') || 'Phone',
            value: 'phone',

            'data-track': 'phone',
            'data-track-value': 'capture',
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ] as any
      }
    />
  );
};

export default ContactPreferredMethod;
